import { useEffect, useState } from 'react';

import { UserRelationship } from '../types/networking';
import { apiMain } from 'services/apiService';

export function useUserRelationship(userId1: string, userId2: string) {
  const [relationship, setRelationship] = useState<UserRelationship | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    setLoading(true);
    setError(null);

    apiMain
      .get<UserRelationship>(`/networking/v1/relationships/${userId1}/${userId2}`)
      .then(res => setRelationship(res.data))
      .catch(err => {
        setError(err.message || 'Erro ao buscar relacionamento');
        setRelationship(null);
      })
      .finally(() => setLoading(false));
  }, [userId1, userId2, refreshTrigger]);

  return { relationship, loading, error, refresh };
}
